export default "__VITE_ASSET__C_d_XaHq__"